"use client";
import { jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Text } from "@nxt-costco-com/forge-components";
import { ColorTextMedium } from "@nxt-costco-com/forge-design-tokens";
import "../../BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../BrowseContext/hook.js";
function WarehouseLocation() {
  const { bdWarehouseNumber } = useBrowseContext();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsVisible(true);
    }
  }, []);
  if (!(bdWarehouseNumber == null ? void 0 : bdWarehouseNumber.value) || !isVisible) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Text, { sx: { color: ColorTextMedium }, variant: "t6", children: [
    "Location: ",
    bdWarehouseNumber.value
  ] });
}
export {
  WarehouseLocation
};
